import React from "react"
import FontIcon from "material-ui/FontIcon"
import { amber500, orange900, green500 } from "material-ui/styles/colors"
import { IPunchDocument, ERecordSearchFilter, EExceptionReviewDialogExceptionType } from "../../models"
interface IProps {
    punch: IPunchDocument
    selectedFilter?: ERecordSearchFilter
    onClickException?(punchId: string, punchExceptionType: EExceptionReviewDialogExceptionType): void
}

const RecordExceptionColumn: React.SFC<IProps> = (props: IProps) => {
    const styles = {
        icon: {
            marginLeft: "5px",
            marginRight: "5px"
        },
        clickable: {
            cursor: "pointer",
            width: 30,
            float: "left"
        }
    }
    const displayBiometricException =
        props.punch.PunchExceptions &&
        props.punch.PunchExceptions.some(function (element, index, array) {
            return element.Type === "BIOMETRIC" && (element.RevisedScore === 0 || element.RevisedScore === -1)
        })

    return (
        <div style={{ width: 60, margin: "0 auto" }}>
            {displayBiometricException &&
                <div>
                    <div
                        style={styles.clickable}
                        onClick={() =>
                            props.onClickException &&
                            [ERecordSearchFilter.All, ERecordSearchFilter.BioExceptions, ERecordSearchFilter.SuspensePunches].includes(props.selectedFilter) &&
                            props.onClickException(props.punch.Id, EExceptionReviewDialogExceptionType.Biometric)
                        }
                    >
                        <FontIcon
                            data-intercom-target={`ExceptionColumn${props.punch && props.punch.Id}-Btn-OpenBiometricExceptionDialog`}
                            color={
                                props.punch.PunchExceptions &&
                                    props.punch.PunchExceptions.some(function (element, index, array) {
                                        return element.Type === "BIOMETRIC" && element.Reviewed
                                    })
                                    ? props.punch.PunchExceptions.some(function (element, index, array) {
                                        return element.Type === "BIOMETRIC" && element.Approved
                                    })
                                        ? green500
                                        : orange900
                                    : amber500
                            }
                            style={styles.icon}
                            className={
                                props.punch.PunchExceptions &&
                                    props.punch.PunchExceptions.some(function (element, index, array) {
                                        return element.Type === "BIOMETRIC"
                                    })
                                    ? "fa fa-user"
                                    : ""
                            }
                        />
                    </div>
                </div>
            }
            {props.punch.PunchExceptions &&
                props.punch.PunchExceptions.some(function (element, index, array) {
                    return element.Type === "LOCATION" || element.Type === "MICRO_LOCATION" || element.Type === "NO_LOCATION_OR_MICROLOCATION" || element.Type === "NO_DEVICE_LOCATION"
                }) &&
                <div>
                    <div
                        style={styles.clickable}
                        onClick={() =>
                            props.onClickException &&
                            [ERecordSearchFilter.All, ERecordSearchFilter.LocExceptions, ERecordSearchFilter.SuspensePunches].includes(props.selectedFilter) &&
                            props.onClickException(props.punch.Id, EExceptionReviewDialogExceptionType.Location)
                        }
                    >
                        <FontIcon
                            data-intercom-target={`ExceptionColumn-${props.punch && props.punch.Id}-Btn-OpenLocationExceptionDialog`}
                            color={
                                props.punch.PunchExceptions &&
                                    props.punch.PunchExceptions.some(function (element, index, array) {
                                        return (
                                            (element.Type === "LOCATION" ||
                                                element.Type === "MICRO_LOCATION" ||
                                                element.Type === "NO_LOCATION_OR_MICROLOCATION" ||
                                                element.Type === "NO_DEVICE_LOCATION") &&
                                            element.Reviewed
                                        )
                                    })
                                    ? props.punch.PunchExceptions.some(function (element, index, array) {
                                        return (
                                            (element.Type === "LOCATION" ||
                                                element.Type === "MICRO_LOCATION" ||
                                                element.Type === "NO_LOCATION_OR_MICROLOCATION" ||
                                                element.Type === "NO_DEVICE_LOCATION") &&
                                            element.Approved
                                        )
                                    })
                                        ? green500
                                        : orange900
                                    : amber500
                            }
                            style={styles.icon}
                            className={
                                props.punch.PunchExceptions &&
                                    props.punch.PunchExceptions.some(function (element, index, array) {
                                        return (
                                            element.Type === "LOCATION" || element.Type === "MICRO_LOCATION" || element.Type === "NO_LOCATION_OR_MICROLOCATION" || element.Type === "NO_DEVICE_LOCATION"
                                        )
                                    })
                                    ? "fa fa-location-arrow"
                                    : ""
                            }
                        />
                    </div>
                </div>
            }
            <div style={{ clear: "both" }} />
        </div>
    )
}

export default RecordExceptionColumn
